import React, { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import optionsSelectors from '../../../../store/selectors/optionsSelectors';
import { carConfigurationActions } from '../../../../store/reducers/carConfigurationReducer';
import carConfigurationSelectors from '../../../../store/selectors/carConfigurationSelectors';
import AccessoryPacksSection from './accessoryPacksSection/AccessoryPacksSection';
import IExtendedAccessoryPack from '../../../../model/accessories/IExtendedAccessoryPack';
import ScrollToWrapper from '../../../presentational/ScrollToWrapper';
import { CustomiseSections } from '../../../../../common/enum/CustomiseSections';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import thunkActions from '../../../../store/actions/thunkActions';
import useBuildDealPacksPayload from '../../../../react/controls/useBuildDealPacksPayload';
import { ROUTES } from '../../../../../common/constants/routes';
import useWidgetContext from '../../../../../common/react/useWidgetContext';

const AccessoryPacksContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const optionsLoading = useSelector(optionsSelectors.getOptionsLoadingState);
  const optionsError = useSelector(optionsSelectors.getOptionsErrorState);
  const selectedPacks = useSelector(carConfigurationSelectors.getSelectedAccessoryPacks);
  const availablePacks: IExtendedAccessoryPack[] = useSelector(optionsSelectors.getAccessoryPacks);
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const { buildDealPayload } = useBuildDealPacksPayload(ROUTES.CONFIGURE);
  const {
    configuration: { dimensions },
  } = useWidgetContext();

  const togglePack = async (optionId: string) => {
    const initRequest = buildDealPayload(optionId);
    const { payload } = (await dispatch(thunkActions.initBasket({ initRequest, priceDisplay, dimensions }))) as any;

    if (payload) {
      // @TODO: Refactor when deal decoupled from basket.
      dispatch(carConfigurationActions.setDataFromDeal(payload.deal));
    }
  };

  if (!optionsLoading && !optionsError && availablePacks.length === 0) {
    return null;
  }

  return (
    <ScrollToWrapper target={CustomiseSections.PACKS} data-test={'container:section:accessory_packs'}>
      <AccessoryPacksSection
        packs={availablePacks}
        selectedPacks={selectedPacks}
        onSelect={togglePack}
        loading={optionsLoading}
        error={optionsError}
      />
    </ScrollToWrapper>
  );
};

export default AccessoryPacksContainer;
